var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.threadId
        ? _c("BlubberPanel", {
            attrs: {
              threadId: _vm.threadId,
              search: _vm.search,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#blubber-search-widget",
            name: "sidebar-blubber-search",
          },
        },
        [
          _c("BlubberSearchWidget", {
            attrs: {
              search: _vm.search,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#blubber-threads-widget",
            name: "sidebar-blubber-threads",
          },
        },
        [
          _c("BlubberThreadsWidget", {
            staticClass: "blubber_threads_widget",
            attrs: {
              hasMoreThreads: _vm.hasMoreThreads,
              threadId: _vm.threadId,
              threads: _vm.threads,
            },
            on: {
              "load-more-threads": _vm.onLoadMoreThreads,
              "select-thread": _vm.onSelectThread,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }